import { CountDownTypes } from '../../types/components'
import React, { useState, useEffect } from 'react'
import { SecondText, CircleSvg } from './style'

const CountDownTimer = ({
	seconds,
	size,
	strokeColor,
	strokeBgColor,
	strokeWidth,
	textColor,
	style,
	timerStatus,
	handleTimerStatus,
}: CountDownTypes) => {
	const milliseconds = seconds * 1000
	const radius = size / 2
	const circumference = size * Math.PI

	const [countdown, setCountdown] = useState(seconds * 1000)
	const [strokeValue, setStrokeValue] = useState(0)
	const [intervalId, setIntervalID] = useState(0)
	let interval: number

	const strokeDashoffset = (value: number) => {
		setStrokeValue(value)
	}

	useEffect(() => {
		if (timerStatus && countdown > 0) {
			interval = window.setTimeout(
				() => setCountdown(countdown - 1000),
				1000
			)
			setIntervalID(interval)
		}
	}, [countdown, timerStatus])

	useEffect(() => {
		strokeDashoffset(
			circumference - (countdown / milliseconds) * circumference
		)
		if (countdown === 0) {
			clearInterval(intervalId)
			handleTimerStatus()
		}
	}, [countdown])

	const styles = {
		countdownContainer: {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			position: 'absolute',
			margin: 'auto',
			height: size,
			width: size,
			marginTop: style,
		} as React.CSSProperties,
		svg: {
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			transform: 'rotateY(-180deg) rotateZ(-90deg)',
			overflow: 'visible',
		} as React.CSSProperties,
		button: {
			fontSize: 16,
			padding: '15px 40px',
			margin: '10px auto 30px',
			display: 'block',
			backgroundColor: '#4d4d4d',
			color: 'lightgray',
			border: 'none',
			cursor: 'pointer',
			outline: 0,
		},
	}

	const second = (countdown / 1000).toFixed()
	return (
		<>
			{/* <button
				style={styles.button}
				onClick={!isPlaying ? startTimer : () => {}}
			>
				START
			</button> */}
			<div style={styles.countdownContainer}>
				<SecondText textColor={textColor} size={size}>
					{second}
				</SecondText>
				<CircleSvg style={styles.svg}>
					<circle
						cx={radius}
						cy={radius}
						r={radius}
						fill="none"
						stroke={strokeBgColor}
						strokeWidth={strokeWidth}
					></circle>
				</CircleSvg>
				<CircleSvg style={styles.svg}>
					<circle
						strokeDasharray={circumference}
						strokeDashoffset={strokeValue}
						r={radius}
						cx={radius}
						cy={radius}
						fill="#142864"
						strokeLinecap="round"
						stroke={strokeColor}
						strokeWidth={strokeWidth}
					></circle>
				</CircleSvg>
			</div>
		</>
	)
}

export default CountDownTimer
